module.exports = __webpack_public_path__ + "static/Group 468-b3ffcd39afa0eb2045f2902b96a8a988.png";